
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "api": {
    "baseUrl": "https://api.aihomedesign.com/v1"
  },
  "pusher": {
    "key": "3a4ae5684d75939f115d",
    "cluster": "us2"
  },
  "nuxt": {
    "buildId": "45b5c47c-6eb1-4723-97da-79ec2478b858"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
